export default "__VITE_ASSET__DQYMXsO4__"